import { UserTier } from '$lib/domains/shared/types.js';

export const PAYMENT_PLANS = [
  {
    name: 'Hobby',
    price: 'Free forever',
    description: 'Great for kicking the tires or for your personal stuff.',
    tldr: 'Validate your MVP in minutes. Zero friction, zero cost.',
    features: [
      { name: 'Max 5 domains' },
      { name: 'Max 5 apps' },
      { name: 'Max 5 HTTP monitors' },
      { name: 'Max 1 status page' },
      { name: 'Historical uptime charts' },
      { name: 'Max 5 metrics per app' },
      { name: 'Max 1 collaborator per domain' },
      { name: 'Monitoring channels (Telegram & Basic Webhooks)' },
      { name: '24 hours logs retention (240k logs per app)' },
      { name: '24 hours metrics retention' },
      { name: 'Quick insights with short-term data granularity' },
      { name: 'Feature requests' },
      { name: 'Vibrant Discord community' },
    ],
    badge: {
      text: 'No credit card required',
    },
    buttonText: 'Select Hobby',
    guarantee: 'No commitment required',
    tier: UserTier.FREE,
    popular: false,
  },
  {
    name: 'Builder',
    price: '$9/mo',
    period: 'per month',
    description: 'When things are getting more serious.',
    tldr: 'Your 24/7 safety net. We watch the servers so you can sleep.',
    features: [
      { name: 'Everything in Hobby, plus:' },
      { name: 'Max 20 domains' },
      { name: 'Max 20 apps' },
      { name: 'Max 20 HTTP monitors' },
      { name: 'Max 5 status pages' },
      { name: 'Max 10 metrics per app' },
      { name: 'Max 2 collaborators per domain' },
      { name: 'Monitoring channels (Telegram & Advanced Webhooks)' },
      { name: '7 days logs retention (4.2M logs per app)' },
      { name: '7 days metrics retention' },
      { name: 'Comprehensive insights with extended data granularity' },
      { name: 'Priority support' },
      { name: 'Dedicated Discord channel with us' },
      { name: 'Regular catch-up calls' },
      { name: 'Early access to new features' },
      { name: 'Priority feature requests' },
    ],
    badge: {
      text: 'Save 10%',
    },
    buttonText: 'Start free trial',
    guarantee: 'No commitment required',
    tier: UserTier.BUILDER,
    popular: false,
  },
  {
    name: 'Pro',
    price: '$15/mo',
    period: 'per month',
    description: '"Sky is the limit" option for seasoned professionals.',
    tldr: 'Take the training wheels off, forget about the limits & squeeze every drop of juice from logdash.',
    features: [
      { name: 'Everything in Builder, plus:' },
      { name: 'Max 50 domains' },
      { name: 'Max 50 apps' },
      { name: 'Max 50 HTTP monitors' },
      { name: 'Max 15 status pages' },
      { name: 'Max 30 metrics per app' },
      { name: 'Max 3 collaborators per domain' },
      { name: 'Monitoring channels (Telegram & Advanced Webhooks)' },
      { name: '30 days logs retention (37M logs per app)' },
      { name: '30 days metrics retention' },
      { name: '99.9% uptime SLA' },
      { name: 'Advanced insights with detailed data granularity' },
      { name: 'Team management features' },
      { name: 'Custom branding options' },
      { name: 'Custom status page domain' },
      { name: 'Push pings' },
    ],
    badge: {
      text: 'Save 50%',
    },
    buttonText: 'Start free trial',
    guarantee: 'No commitment required',
    tier: UserTier.PRO,
    popular: true,
  },
] as const;

export const trialTier = (
  value: string | null,
): UserTier.BUILDER | UserTier.PRO | undefined =>
  value === UserTier.BUILDER || value === UserTier.PRO ? value : undefined;
